<h2 mat-dialog-title class="text-xl font-semibold text-gray-900 mb-2">Add Operator to Group</h2>

<div mat-dialog-content class="space-y-4">
    <div class="bg-gray-50 p-3 rounded-lg">
        <p class="text-sm font-medium text-gray-700">Group: <span class="text-gray-900">{{ group.name }}</span></p>
        <p class="text-sm text-gray-600">Role: <span class="font-medium">{{ group.role }}</span></p>
    </div>

    @if (isLoading()) {
    <div class="flex items-center justify-center py-6">
        <mat-spinner diameter="40"></mat-spinner>
        <span class="ml-3 text-gray-600">Loading operators...</span>
    </div>
    } @else if (availableOperators().length === 0) {
    <div class="text-center py-6 text-gray-500">
        <p>All operators are already members of this group.</p>
    </div>
    } @else {
    <mat-form-field appearance="fill" class="w-full">
        <mat-label>Select Operator</mat-label>
        <mat-select [value]="selectedOperatorId()" (valueChange)="selectedOperatorId.set($event)"
            [disabled]="isAdding()">
            <mat-option value="">-- Select an operator --</mat-option>
            @for (operator of availableOperators(); track operator.id) {
            <mat-option [value]="operator.id">
                {{ getOperatorDisplayName(operator) }}
                @if (operator.email) {
                <span class="text-xs text-gray-500"> — {{ operator.email }}</span>
                }
            </mat-option>
            }
        </mat-select>
    </mat-form-field>
    }

    @if (isAdding()) {
    <div class="flex items-center gap-2 text-gray-600 text-sm">
        <mat-spinner diameter="20"></mat-spinner>
        <span>Adding operator...</span>
    </div>
    }
</div>

<div mat-dialog-actions class="flex gap-3 pt-4">
    <button mat-button (click)="onCancel()" [disabled]="isAdding()" class="flex-1">Cancel</button>
    <button mat-raised-button color="primary" (click)="onAdd()"
        [disabled]="!selectedOperatorId() || isAdding() || availableOperators().length === 0" class="flex-1">
        @if (!isAdding()) { Add } @else { Adding... }
    </button>
</div>